@if (navbar()) {
  <app-navbar [overlay]="navbarOverlay()" />
}

<main
  class="flex flex-1 flex-col overflow-x-clip"
  [class.py-10]="padded()"
  [class.sm:py-14]="padded()"
>
  <div
    class="mx-auto w-full px-4 sm:px-6 lg:px-8"
    [class]="maxWidthClass()"
  >
    <ng-content />
  </div>
</main>

@if (footer()) {
  <app-footer />
}
